export default "__VITE_ASSET__DhrgXl$u__"